import dynamic from 'next/dynamic';

import { SaveToProfileBannerProps } from './index.types';

export const SaveToProfileBanner = dynamic<SaveToProfileBannerProps>(
  () => import('./SaveToProfileBanner').then(module => module.SaveToProfileBanner),
  { ssr: false }
);

export { SaveToProfileModal } from './SaveToProfileModal';
export type { SaveToProfileModalProps } from './index.types';
